import React from "react";
import { Box, Container, Typography, Link, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const linkStyle = {
    color: "rgba(0,0,0,0.7)",
    textDecoration: "none",
    fontSize: "0.95rem",
    transition: "0.25s ease",
    "&:hover": {
      color: "#3a7b3e",
    },
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#fff",
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Divider sx={{ mb: 5, opacity: 0.5 }} />

        {/* 🔥 FIX: alignItems START statt CENTER */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr" },
            gap: 6,
            alignItems: "start",
          }}
        >
          {/* LINKS */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.2,
              alignItems: { xs: "center", md: "flex-start" },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            <Link component={RouterLink} to="/impressum" sx={linkStyle}>
              Impressum
            </Link>

            <Link component={RouterLink} to="/datenschutz" sx={linkStyle}>
              Datenschutz
            </Link>

            <Link
              href="https://corpshaus2.de/"
              target="_blank"
              rel="noopener"
              sx={linkStyle}
            >
              Intern
            </Link>
          </Box>

          {/* LOGO (sauber zentriert, aber ohne Grid-Verschiebung) */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box
              onClick={() => scrollToSection("#home")}
              sx={{
                cursor: "pointer",
                opacity: 0.9,
                transition: "0.25s ease",
                "&:hover": {
                  opacity: 1,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Box
                component="img"
                src="/Corps_Guestphalia_Berlin_Logo_01.png"
                alt="Corps Guestphalia Berlin"
                sx={{
                  height: { xs: 100, md: 140 },
                  width: "auto",
                }}
              />
            </Box>
          </Box>

          {/* KONTAKT */}
          <Box
            sx={{
              textAlign: { xs: "center", md: "right" },
              display: "flex",
              flexDirection: "column",
              gap: 0.5,
              alignItems: { xs: "center", md: "flex-end" },
            }}
          >
            <Typography
              sx={{
                fontSize: "0.95rem",
                lineHeight: 1.7,
                color: "rgba(0,0,0,0.75)",
              }}
            >
              <Box sx={{ fontWeight: 600, color: "#111", mb: 0.8 }}>
                Corps Guestphalia Berlin
              </Box>

              Schwendenerstrasse 13
              <br />
              14195 Berlin-Dahlem
              <br />
              <br />
              Tel.: 030 - 83 227 866
              <br />
              adh@guestphalia-berlin.de
            </Typography>
          </Box>
        </Box>

        {/* Bottom line */}
        <Divider sx={{ mt: 6, opacity: 0.4 }} />

        <Typography
          sx={{
            mt: 3,
            textAlign: "center",
            fontSize: "0.8rem",
            color: "rgba(0,0,0,0.45)",
            letterSpacing: "0.08em",
          }}
        >
          © {new Date().getFullYear()} Corps Guestphalia Berlin
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;